// src/components/products/ProductForm/TourDetailsSections/TourGuidanceSection.jsx

import React from "react";
import { Grid } from "@mui/material";
import FormInput from "../../../inputs/FormInput";

const TourGuidanceSection = ({
    formData,
    errors,
    activeLang,
    handleMultiLangChange,
}) => {
    const showArabic = activeLang === "ar";
    const showEnglish = activeLang === "en";

    return (
        <Grid container spacing={3}>
            {/* What to Bring - Arabic */}
            {showArabic && (
                <Grid item xs={12} md={6}>
                    <FormInput
                        label="ماذا تحضر معك (عربي)"
                        type="editor"
                        textareaRows={200}
                        name="what_to_bring_ar"
                        value={formData.what_to_bring?.ar || ''}
                        onChange={(e) => handleMultiLangChange('what_to_bring', 'ar', e.target.value)}
                        rows={3}
                        error={!!errors.what_to_bring_ar}
                        helperText={errors.what_to_bring_ar}
                    />
                </Grid>
            )}

            {/* What to Bring - English */}
            {showEnglish && (
                <Grid item xs={12} md={6}>
                    <FormInput
                        label="What to Bring (English)"
                        type="editor"
                        textareaRows={200}
                        name="what_to_bring_en"
                        value={formData.what_to_bring?.en || ''}
                        onChange={(e) => handleMultiLangChange('what_to_bring', 'en', e.target.value)}
                        rows={3}
                        error={!!errors.what_to_bring_en}
                        helperText={errors.what_to_bring_en}
                    />
                </Grid>
            )}

            {/* Voucher Notes - Arabic */}
            {showArabic && (
                <Grid item xs={12} md={6}>
                    <FormInput
                        label="ملاحظات القسيمة (عربي)"
                        type="editor"
                        textareaRows={200}
                        name="voucher_notes_ar"
                        value={formData.voucher_notes?.ar || ''}
                        onChange={(e) => handleMultiLangChange('voucher_notes', 'ar', e.target.value)}
                        rows={3}
                        error={!!errors.voucher_notes_ar}
                        helperText={errors.voucher_notes_ar}
                    />
                </Grid>
            )}

            {/* Voucher Notes - English */}
            {showEnglish && (
                <Grid item xs={12} md={6}>
                    <FormInput
                        label="Voucher Notes (English)"
                        type="editor"
                        textareaRows={200}
                        name="voucher_notes_en"
                        value={formData.voucher_notes?.en || ''}
                        onChange={(e) => handleMultiLangChange('voucher_notes', 'en', e.target.value)}
                        rows={3}
                        error={!!errors.voucher_notes_en}
                        helperText={errors.voucher_notes_en}
                    />
                </Grid>
            )}
        </Grid>
    );
};

export default TourGuidanceSection;
